
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    SCHEDULED_ACTIONS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    scheduledActionsResult,
} from 'Redux/actions';


function* deleteScheduledAction({ payload }) {
    try {
        let QUERY = `
            mutation deleteScheduledAction ($ids: [Int!]) {
                result: deleteScheduledAction (ids: $ids)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                ids: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(scheduledActionsResult({ delete: data?.result }))
        } else {
            yield put(scheduledActionsResult({ delete: false }))
        }

    } catch (exc) {
        yield put(scheduledActionsResult({ delete: false }))
        ExceptionManager(exc, 'Modules/scheduledActions/views/components/deleteScheduledAction/redux/saga', 'deleteScheduledAction');
    }
}

function* watchMethods() {
    yield takeEvery(SCHEDULED_ACTIONS_REQUEST, deleteScheduledAction);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}